<div class="overlay" *ngIf="isVisible" (click)="close()">
  <div class="popup" (click)="$event.stopPropagation()">

    <!-- ============================= -->
    <!-- MAIN SHIPMENTS TABLES -->
    <!-- ============================= -->

    <div class="receipt-table-container">
      <h5 *ngIf="shipments?.length > 0">
        <b>{{ 'common.dropOff' | translate }}</b>
      </h5>

      <div *ngFor="let shipment of shipments; let sIndex = index">

        <div *ngFor="let item of shipment.ItemsList; let iIndex = index">

          <table class="table table-bordered table-striped receipt-table">
            <thead>
              <tr>
                <th colspan="2">
                  <b>{{ 'pages.createReceiptPage.oneReceipt.table.hawb' | translate }}</b>
                </th>
                <th colspan="2"><b>Item Number</b></th>
                <th><b>Packing</b></th>
                <th><b>CustomsValue</b></th>
                <th><b>Pieces</b></th>
                <th><b>Description</b></th>
                <th><b>Reference</b></th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td colspan="2">
                  <span class="armx-icon armx-trash delete-btn" (click)="removeItem(sIndex, iIndex)">
                  </span>
                  {{ shipment.Waybill_No }}
                </td>

                <td colspan="2">{{ item.ItemNumber }}</td>
                <td>{{ item.Packing }}</td>
                <td>{{ item.CustomsValue }}</td>
                <td>{{ item.Pieces }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.reference }}</td>
              </tr>

              <tr *ngIf="item.scannedCount > 0">
                <td colspan="9">
                  <div style="background:#f5f5f5; padding:10px; border-radius:6px;">

                    <b>Scanned Info:</b>

                    <div>
                      Item: {{ item.ItemNumber }}
                    </div>

                    <div>
                      Scanned Count: {{ item.scannedCount }}
                    </div>

                  </div>
                </td>
              </tr>


              <tr *ngIf="item.isToggled">
                <td colspan="9">
                  <div class="input-group">
                    <label>
                      <span class="input-icon">📦</span>
                      Damaged shipment count
                    </label>

                    <input type="number" min="0" [(ngModel)]="item.damagedCount" (input)="updateTotalDamagedCount()"
                      placeholder="Enter count" class="form-control" style="width:150px; margin-left:10px;" />
                  </div>
                </td>
              </tr>
            </tbody>

          </table>
          <div>
            <td colspan="2">
              <div class="scan-container">
                <div class="scan-input-wrapper">
                  <span class="scan-icon">📦</span>
                  <input type="text" placeholder="Scan or enter barcode..."
                    (keyup.enter)="onScan($event.target.value); $event.target.value=''" />
                  <span class="scan-hint">Scan</span>
                  <button
  type="button"
  class="btn btn-warning"
  style="margin-left:10px;"
  (click)="resetItemScan(shipment, item)">
  Reset Scan
</button>
                </div>
              </div>
            </td>
          </div>

          <!-- Toggle -->
          <label class="switch">          
            <input type="checkbox" [(ngModel)]="item.isToggled" (change)="updateTotalDamagedCount()" />
            <span class="slider round"></span>

          </label>
              <div class="toggle-text">Damaged Logic</div>

          <!-- Webcam -->
          <div *ngIf="item.isToggled">
            <div class="input-group">
              <button (click)="openWebcam(sIndex, iIndex, shipment)">
                📷 Open Camera
              </button>
            </div>

            <!-- ✅ Scoped to this specific item only -->
            <div class="webcam-container" *ngIf="isWebcamOpen(sIndex, iIndex)">
              <webcam [height]="320" [width]="480" [trigger]="triggerObservable"
                (imageCapture)="handleWebcamCapturedImage($event.imageAsDataUrl, shipment, item)">
              </webcam>
              <button class="btn btn-danger" (click)="triggerSnapshot()">
                📸 Capture
              </button>
              <button class="btn btn-danger" (click)="closeWebcam(sIndex, iIndex)">
                Close
              </button>
              <div *ngIf="uploadMessage" class="capture-status">
                <div class="status-text">{{ uploadMessage }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="receipt-table-container" *ngIf="totalDamagedCount > 0">

      <table class="receipt-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Shipment Number</th>
            <th>Item Number</th>
            <th>Damaged Count</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let shipment of shipments; let sIndex = index">
            <ng-container *ngFor="let item of shipment.ItemsList; let iIndex = index">

              <tr *ngIf="item.damagedCount > 0">
                <td>{{ sIndex + 1 }}.{{ iIndex + 1 }}</td>
                <td>{{ shipment.Waybill_No }}</td>
                <td>{{ item.ItemNumber }}</td>
                <td>{{ item.damagedCount }}</td>
              </tr>
            </ng-container>
          </ng-container>

          <tr class="total-row">
            <td colspan="3">
              Total Damaged Count:
            </td>
            <td style="color:#e53935; font-weight:700;">
              {{ totalDamagedCount }}
            </td>
          </tr>
          <tr>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Captured images: preview, progress, confirm upload -->
    <div class="pending-images-section" *ngIf="PendingImages.length > 0 || isUploading || uploadCompleted">
      <h5><b>Captured Images Review</b></h5>

      <div class="upload-progress-panel" *ngIf="isUploading || uploadCompleted">
        <div>Pending: {{ PendingImages.length }}</div>
        <div>Processed: {{ uploadProcessedCount }}</div>
        <div>Success: {{ uploadSuccessCount }}</div>
        <div>Failed: {{ uploadFailedCount }}</div>
      </div>

      <div *ngIf="uploadMessage" class="capture-status upload-status-banner">
        <div class="status-text">{{ uploadMessage }}</div>
      </div>

      <div class="pending-images-grid" *ngIf="PendingImages.length > 0">
        <div class="pending-image-card" *ngFor="let image of PendingImages">
          <img [src]="image.previewUrl" [alt]="image.fileName" class="pending-image-thumbnail" />
          <div class="pending-image-name">{{ image.fileName }}</div>
          <div class="pending-image-meta">{{ image.shipmentNumber }} | {{ image.itemNumber }}</div>
          <button type="button" class="btn btn-danger" [disabled]="isUploading" (click)="removePendingImage(image.localId)">
            Remove
          </button>
        </div>
      </div>

      <div class="upload-actions">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="isUploading || PendingImages.length === 0"
          (click)="confirmUpload()">
          {{ isUploading ? 'Uploading...' : 'Confirm Upload' }}
        </button>
      </div>
    </div>

    <div *ngIf="missmatches.length > 0" class="error-message">
      Discrepancy found. Missing or extra items:
      <span>{{ missmatches }}</span>
    </div>
    <div *ngIf="mismatchesDamagedvsImages.length > 0" class="error-message">
      <p>Please retake photos for the following damaged items:</p>
      <ul>
        <li *ngFor="let item of mismatchesDamagedvsImages">
          {{ item }}
        </li>
      </ul>
    </div>
    <div style="margin-top:15px; text-align:right;">
      <button class="btn btn-danger" (click)="close()">
        Close
      </button>

      

      <button class="btn btn-info" (click)="addToReceiptClick()">
        {{ 'common.addToReceipt' | translate }}
      </button>
    </div>
  </div>